const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2019 - 2023",
    title: "Bachelor of Technology (B.Tech)",
    desc: "Specialization in Computer Science and Engineering (CSE) with a CGPA of 8.68",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2017 - 2018",
    title: "Intermediate (12th)",
    desc: "Scored 96.7% in the Higher Secondary Certificate (HSC) examination",
  },
  {
    id: 3,
    category: "education",
    icon: "icon-graduation",
    year: "2015 - 2016",
    title: "10th Grade",
    desc: "Scored a cgpa of 9.8 in the Secondary School Certificate (SSC) exmination",
  },
  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "2024 - present",
    title: "Full Stack Developer - Solkuu Technologies Pvt. Ltd.",
    desc: "Developed a responsive product showcase website using Next.js, TypeScript, and Tailwind CSS. Leading the development of a retail operations web portal with Next.js, TypeScript, and Material-UI. Driving end-to-end development of a customer mobile app using React Native and TypeScript. Implementing backend APIs with Node.js, Express, Redis, and PostgreSQL to ensure robust functionality and timely delivery.",
  },
  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "2024",
    title: "Software Engineer - Solkuu Technologies Pvt. Ltd.",
    desc: "Independently developed Sharescan app from scratch, leveraging React Native and Tailwind CSS for a user-friendly QR code solution. Additionally, built responsive websites in Next.js and Tailwind CSS for high-performance and modern design elements.",
  },
  {
    id: 6,
    category: "experience",
    icon: "icon-briefcase",
    year: "2023 - 2024",
    title: "Software Developer Intern - Digicore Technologies Pvt. Ltd.",
    desc: "Revamped ClinicSpots app with new features using React Native/Redux, built intuitive dashboards for real-time lead access, and contributed 20+ bug fixes/UI enhancements across platforms.",
  },
];

export default Data;
